export default __webpack_public_path__ + "static/4-d9ccdd2c2cfd3ba17fa01c7e8574c286.jpeg";